// extracted by mini-css-extract-plugin
export default {"root":"DrawerHeader_root__DaPc2","dark":"DrawerHeader_dark__Jt2k6","backBtn":"DrawerHeader_backBtn__II-Tz"};